<template lang="pug">
  section.employees-list-db
    v-card-title
      h3 Сотрудники
    v-card-text
      v-layout(row justify-center)
        v-btn(large color="success" @click.prevent="createNewEmployee").mb-4
          v-icon.mr-2 add
          span Создать
      v-layout(row justify-center).pb-4
        v-flex(xs11)
          v-data-table(
            :headers="headers",
            :items="employeeList",
            :loading="loading",
            no-data-text="Нет данных для отображения",
            hide-actions)
            template(slot="items" slot-scope="props")
              td {{props.index+1}}
              td {{props.item.name}}
              td {{isAdmin(props.item.isAdmin)}}
              td
                a(@click="editEmployee(props.item.id)") Редактировать
              td
                a(@click="openModal(props.item.id, props.item.name)" class="red--text") Удалить
      v-layout(row justify-center).pb-4
        v-pagination(v-model="page", :length="pageCount", :total-visible="15")
    DeleteDialog(
      :show="dialog",
      :loading="deleteEmployeeLoading",
      dispatchType="employee",
      @close-dialog="closeDialog",
      @delete-employee="deleteEmployee")
      div(slot="title") Вы действительно хотите удалить,<br><b>{{ employeeName }}</b>?
</template>

<script>
import DeleteDialog from '../Common/DeleteDialog/DeleteDialog'
export default {
  name: 'EmployeesList',
  components: { DeleteDialog },
  data() {
    return {
      page: 1,
      pageSize: 10,
      headers: [
        { text: '№', value: 'id', sortable: false },
        { text: 'ФИО', value: 'name' },
        { text: 'Должность', value: 'position' },
        { text: 'Действие', value: 'action1', sortable: false },
        { text: 'Действие', value: 'action2', sortable: false }
      ],
      dialog: false,
      employeeId: '',
      employeeName: ''
    }
  },
  mounted() {
    this.$store.dispatch('GET_EMPLOYEE_LIST', { pageNumber: this.page, pageSize: this.pageSize })
    this.$store.dispatch('GET_DB_ACCESS_LIST')
  },
  watch: {
    page(val) {
      this.$store.dispatch('GET_EMPLOYEE_LIST', { pageNumber: val, pageSize: this.pageSize })
    }
  },
  computed: {
    employeeList() {
      return this.$store.state.employee.employeeList.data
    },
    pageCount() {
      return this.$store.state.employee.employeeList.pageCount
    },
    deleteEmployeeLoading() {
      return this.$store.state.employee.loading.deleteEmployeeLoading
    },
    loading() {
      return this.$store.state.employee.loading.employeeListLoading
    }
  },
  methods: {
    createNewEmployee() {
      this.$router.push({ path: '/main/employee/add' })
    },
    isAdmin(val) {
      return val ? 'Администратор' : 'Пользователь'
    },
    editEmployee(id) {
      this.$router.push({ path: `/main/employee/edit/${id}` })
    },
    deleteEmployee() {
      this.$store.dispatch('DELETE_EMPLOYEE', this.employeeId)
    },
    openModal(id, name) {
      this.employeeId = id
      this.employeeName = name
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.employeeId = ''
      this.employeeName = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.v-btn {
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Employees/EmployeesList.vue